var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Activities',{attrs:{"objectId":_vm.objectId,"hideUpdate":true,"currentYear":_vm.currentYear,"min-year":_vm.minYear,"max-year":_vm.maxYear,"change-filter":_vm.changeFilter}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }